// 定义初始状态
const initialState = {
  tasks: [],
  loading: false,
  error: null,
  total: 0,
  page: 1,
  limit: 10
};

// 定义动作类型
const FETCH_TASKS_START = 'FETCH_TASKS_START';
const FETCH_TASKS_SUCCESS = 'FETCH_TASKS_SUCCESS';
const FETCH_TASKS_FAIL = 'FETCH_TASKS_FAIL';
const UPLOAD_TASK_START = 'UPLOAD_TASK_START';
const UPLOAD_TASK_SUCCESS = 'UPLOAD_TASK_SUCCESS';
const UPLOAD_TASK_FAIL = 'UPLOAD_TASK_FAIL';
const CANCEL_TASK_SUCCESS = 'CANCEL_TASK_SUCCESS';
const UPDATE_TASK_DETAILS = 'UPDATE_TASK_DETAILS';
const DELETE_TASK_FILES_START = 'DELETE_TASK_FILES_START';
const DELETE_TASK_FILES_SUCCESS = 'DELETE_TASK_FILES_SUCCESS';
const DELETE_TASK_FILES_FAIL = 'DELETE_TASK_FILES_FAIL';
const CLEAR_UPLOAD_ERROR = 'CLEAR_UPLOAD_ERROR';

// 任务reducer
const tasksReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_TASKS_START:
      return {
        ...state,
        loading: true,
        error: null
      };
    case FETCH_TASKS_SUCCESS:
      return {
        ...state,
        tasks: action.payload.tasks,
        total: action.payload.total,
        page: action.payload.page,
        limit: action.payload.limit,
        loading: false,
        error: null
      };
    case FETCH_TASKS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    case UPLOAD_TASK_START:
      return {
        ...state,
        loading: true,
        error: null
      };
    case UPLOAD_TASK_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null
      };
    case UPLOAD_TASK_FAIL:
      // 检查是否应该防止重渲染任务列表
      if (action.preventRerender) {
        return {
          ...state,
          loading: false,
          error: action.payload
          // 不修改tasks、total、page、limit等状态，保持任务列表不变
        };
      }
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    case CANCEL_TASK_SUCCESS:
      return {
        ...state,
        tasks: state.tasks.map(task => 
          task.task_id === action.payload.task_id 
            ? { 
                ...task, 
                status: 'cancelled',
                user_status: 'cancelled',
                points_refunded: action.payload.points_refunded,
                points_balance: action.payload.points_balance
              } 
            : task
        )
      };
    case UPDATE_TASK_DETAILS:
      // 如果有多个任务需要更新
      if (Array.isArray(action.payload)) {
        // 创建一个映射表，方便通过taskId快速查找
        const taskDetailsMap = action.payload.reduce((map, item) => {
          map[item.taskId] = item.taskDetail;
          return map;
        }, {});
        
        // 更新任务列表中匹配的任务
        return {
          ...state,
          tasks: state.tasks.map(task => {
            // 如果当前任务ID在更新列表中
            if (taskDetailsMap[task.task_id]) {
              // 使用任务详情更新任务状态
              return {
                ...task,
                ...taskDetailsMap[task.task_id]
              };
            }
            return task;
          })
        };
      } 
      // 单个任务更新
      else if (action.payload.taskId && action.payload.taskDetail) {
        return {
          ...state,
          tasks: state.tasks.map(task =>
            task.task_id === action.payload.taskId
              ? { ...task, ...action.payload.taskDetail }
              : task
          )
        };
      }
      return state;
    case DELETE_TASK_FILES_START:
      return {
        ...state,
        loading: true,
        error: null
      };
    case DELETE_TASK_FILES_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null
      };
    case DELETE_TASK_FILES_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    case CLEAR_UPLOAD_ERROR:
      return {
        ...state,
        error: null
      };
    default:
      return state;
  }
};

export default tasksReducer;